import React from "react";

import { Row } from "react-flexbox-grid";
import NumericInput from "react-numeric-input";

import withStyles from "@material-ui/core/styles/withStyles";

import InputLabel from "@material-ui/core/InputLabel";
import Tooltip from "@material-ui/core/Tooltip";

import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    // color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  formControl: {
    width: "100%",
  },
  repStatusLegend: {
    padding: "1em .25em",
    display: "flex",
  },
};

const SaveDefaultsButton = (props) => (
  <GridItem xs={12} sm={12} md={6}>
    <Tooltip
      id="save-default-tip"
      title="Click to change default settings"
      placement="top"
    >
      <Button color="scmain" onClick={props.saveMemberAppSettings}>
        Save Defaults
      </Button>
    </Tooltip>
  </GridItem>
);

const AlertSettings = (props) => {
  const MachineErrorsTip =
    "Set desired date range in which to view machine errors at your locations";
  const minThresholdAlertTip = `Set the lower limit for cassette capacity. Default is 50 notes before reaching 0.`;
  const maxThresholdAlertTip = `Set the upper limit for cassette capacity. Default is 50 notes before reaching the maximum capacity for that cassette.`;
  const openTillDelayTip =
    "Set the maximum amount of hours to wait before alerting of an open till.  For example, choose the common shift length for workers at your organization.";
  const transDelayTip =
    "Set the maximum amount of hours to wait before warning of possible replication failure at your locations.";

  return (
    <Card>
      <CardHeader color="scmain">
        <h6 className={props.classes.cardTitleWhite}>Settings</h6>
      </CardHeader>
      <CardBody>
        <GridContainer>
          {props.type === "errors" && (
            <div>
              <GridItem xs={12} sm={12} md={12}>
                <Tooltip
                  id="errors-tooltip"
                  title={MachineErrorsTip}
                  placement="top"
                >
                  <h6
                    className={props.classes.cardTitleWhite}
                    style={{ textTransform: "none" }}
                  >
                    View Errors From:
                  </h6>
                </Tooltip>
                <Button
                  id="day-error-button"
                  color={
                    props.memberSettings.machineErrorRange === "day"
                      ? "info"
                      : "white"
                  }
                  onClick={props.handleErrorRangeChanged("day")}
                >
                  Today
                </Button>
                <Button
                  id="week-error-button"
                  color={
                    props.memberSettings.machineErrorRange === "week"
                      ? "info"
                      : "white"
                  }
                  onClick={props.handleErrorRangeChanged("week")}
                >
                  This Week
                </Button>
                <Button
                  id="month-error-button"
                  color={
                    props.memberSettings.machineErrorRange === "month"
                      ? "info"
                      : "white"
                  }
                  onClick={props.handleErrorRangeChanged("month")}
                >
                  This Month
                </Button>
                <Button
                  id="year-error-button"
                  color={
                    props.memberSettings.machineErrorRange === "year"
                      ? "info"
                      : "white"
                  }
                  onClick={props.handleErrorRangeChanged("year")}
                >
                  This Year
                </Button>
              </GridItem>
              <SaveDefaultsButton
                saveMemberAppSettings={props.saveMemberAppSettings}
              />
            </div>
          )}
          {props.type === "threshold" && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Row center="xs">
                  <Tooltip
                    id="min-threshold-tip"
                    title={minThresholdAlertTip}
                    placement="top"
                  >
                    <InputLabel>Set Minimum Threshold</InputLabel>
                  </Tooltip>
                </Row>
                <NumericInput
                  mobile
                  className={props.classes.formControl}
                  min={0}
                  max={2000}
                  size={100}
                  step={10}
                  value={props.memberSettings.minThreshold}
                  onChange={props.handleMinThresholdChanged}
                  style={{
                    width: "100%",
                    wrap: {
                      marginBottom: "10px",
                    },
                    input: {
                      display: "block",
                      fontWeight: 100,
                      width: "100%",
                      height: "35px",
                    },
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Row center="xs">
                  <Tooltip
                    id="max-threshold-tip"
                    title={maxThresholdAlertTip}
                    placement="top"
                  >
                    <InputLabel>Set Maximum Threshold</InputLabel>
                  </Tooltip>
                </Row>
                <NumericInput
                  mobile
                  className={props.classes.formControl}
                  min={0}
                  max={3000}
                  size={100}
                  step={10}
                  value={props.memberSettings.maxThreshold}
                  onChange={props.handleMaxThresholdChanged}
                  style={{
                    width: "100%",
                    wrap: {
                      marginBottom: "10px",
                    },
                    input: {
                      display: "block",
                      fontWeight: 100,
                      width: "100%",
                      height: "35px",
                    },
                  }}
                />
              </GridItem>
              <SaveDefaultsButton
                saveMemberAppSettings={props.saveMemberAppSettings}
              />
            </GridContainer>
          )}
          {props.type === "openTill" && (
            <div>
              <GridItem xs={12} sm={12} md={6}>
                <Row center="xs">
                  <Tooltip
                    id="open-till-tip"
                    title={openTillDelayTip}
                    placement="top"
                  >
                    <InputLabel>Open Till Delay</InputLabel>
                  </Tooltip>
                </Row>
                <NumericInput
                  mobile
                  min={1}
                  max={24}
                  size={100}
                  value={props.memberSettings.openTillDelay}
                  onChange={props.handleOpenTillDelayChange}
                  style={{
                    width: "100%",
                    wrap: {
                      marginBottom: "10px",
                    },
                    input: {
                      display: "block",
                      fontWeight: 100,
                      width: "100%",
                      height: "35px",
                    },
                  }}
                />
              </GridItem>
              <SaveDefaultsButton
                saveMemberAppSettings={props.saveMemberAppSettings}
              />
            </div>
          )}
          {props.type === "replication" && (
            <div>
              <div className={props.classes.repStatusLegend}>
                {/* <p>Status colors:</p> */}
                <GridItem xs={12} sm={12} md={4}>
                  <CardHeader color="warning">
                    <Tooltip
                      id="rep-error-legend"
                      title="Locations with this color may not be replicating, contact support"
                      placement="top"
                    >
                      <h4 className={`${props.classes.cardTitleWhite}`}>
                        Error
                      </h4>
                    </Tooltip>
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CardHeader color="success">
                    <Tooltip
                      id="rep-error-legend"
                      title="Locations with this color are replicating data without error"
                      placement="top"
                    >
                      <h4 className={`${props.classes.cardTitleWhite}`}>
                        Replicating
                      </h4>
                    </Tooltip>
                  </CardHeader>
                </GridItem>
                {/* </div> */}
              </div>
              <GridItem xs={12} sm={12} md={6}>
                <Row center="xs">
                  <Tooltip
                    id="trans-delay-tip"
                    title={transDelayTip}
                    placement="top"
                  >
                    <InputLabel>Transaction/Login Delay</InputLabel>
                  </Tooltip>
                </Row>
                <NumericInput
                  mobile
                  min={1}
                  max={48}
                  size={100}
                  value={props.memberSettings.repStatusDelay}
                  onChange={props.handleRepStatusDelayChange}
                  style={{
                    width: "100%",
                    wrap: {
                      marginBottom: "10px",
                    },
                    input: {
                      display: "block",
                      fontWeight: 100,
                      width: "100%",
                      height: "35px",
                    },
                  }}
                />
              </GridItem>
              <SaveDefaultsButton
                saveMemberAppSettings={props.saveMemberAppSettings}
              />
            </div>
          )}
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(AlertSettings);



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertSettings.jsx